import { format } from "date-fns";

import { MileageModel } from "@interfaces/index";
import { formatAmount } from "@utils/index";

export const TableTdMobileMileage = ({
  mileage,
  isDiBusiness,
  onClickRow,
}: {
  mileage: MileageModel;
  isDiBusiness: boolean;
  onClickRow?: () => void;
}) => (
  <tr onClick={onClickRow} data-testid="tr_mileageTable">
    <td className="rounded-lg border border-black-8 px-4 pb-4 pt-2">
      <div className="flex justify-between">
        <div className="font-bold text-black-100">
          {format(new Date(mileage.dateFrom), "dd.MM.yy")} -{" "}
          {format(new Date(mileage.dateTo), "dd.MM.yy")}
        </div>
        <div className="text-black-54">{mileage.period.title}</div>
      </div>
      <div className="flex justify-between pt-8">
        <div>
          <div className="text-100 text-black-54">
            {isDiBusiness ? "Total" : "Total Miles/Tax Year"}
          </div>
          <div className="text-300 font-bold text-black-100">
            {mileage.totalMiles} miles
          </div>
        </div>
        <div>
          <div className="text-100 text-black-54">Business</div>
          <div className="font-bold text-black-70">
            {mileage.businessMiles} miles
          </div>
        </div>
        <div>
          <div className="text-100 text-black-54">
            {isDiBusiness ? "Private" : "Mileage"}
          </div>
          <div className="font-bold text-black-70">
            {isDiBusiness
              ? `${mileage.privateMiles} miles`
              : `£${formatAmount(mileage.mileageSum)}`}
          </div>
        </div>
      </div>
      <div className="pt-4">
        <div className="text-100 text-black-54">Asset Name</div>
        <div className="font-bold text-black-70">{mileage.asset.name}</div>
      </div>
    </td>
  </tr>
);
